import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { PremiumAction } from "../actions";
import * as premiumApi from "../api/premium";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
import { SetMessage } from "../assets/errorMessages";
import {push, replace} from "connected-react-router";
import {PURCHASE_STEPS_TYPE, PURCHASE_USED_KEY} from "../constants/purchase";
import {createBrowserHistory} from "history";

export function* watcherPremium() {
  yield takeLatest(types.PREMIUM_INIT_REQUEST, worker);
  yield takeLatest(types.PREMIUM_CALCULATE_PRICE_REQUEST, calculatePriceWorker);
  yield takeLatest(types.PREMIUM_BUY_GIFT_REQUEST, buyGiftWorker);
  yield takeLatest(types.PREMIUM_USE_WALLET_REQUEST, useWalletWorker);
  yield takeLatest(types.PREMIUM_USE_PROMO_CODE_REQUEST, usePromoCodeWorker);
  yield takeLatest(types.PREMIUM_TRANSACTION_LIST_REQUEST, getListWorker);
  yield takeLatest(
    types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST,
    getListByProjectWorker
  );
  yield takeLatest(types.PREMIUM_PAY_REQUEST, store);
  yield takeLatest(types.PREMIUM_PROMO_CODE_REQUEST, promoCode);
  yield takeLatest(types.PREMIUM_ACTIVE_PLANS_REQUEST, activePlan);
  yield takeLatest(
    types.PREMIUM_TRANSACTION_ITEM_REQUEST,
    getPremiumTransaction
  );
}

function fetchInit(data) {
  return premiumApi.init(data);
}

function* worker(action) {
  try {
    const response = yield call(
      fetchInit,
      action.data
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PremiumAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PremiumAction.getFailure(message));
  }
}

function calculatePrice(data) {
  return premiumApi.calculatePrice(data);
}

function* calculatePriceWorker(action) {
  try {
    const response = yield call(calculatePrice, action.data);
    yield put(PremiumAction.calculatePriceSuccess(response.data));
    const history = createBrowserHistory();
    if (action.transition) {
      yield put(
        push({
          pathname: history.location.pathname,
          search: history.location.search,
          state: {
            ...history.location.state,
            [PURCHASE_USED_KEY.PLAN_ID]: action.data.plan_id,
            [PURCHASE_USED_KEY.DURATION_ID]: action.data.duration_id,
            [PURCHASE_USED_KEY.FORM_STEP]: PURCHASE_STEPS_TYPE.CONFIRM_PLAN
          }
        })
      );
    }
  } catch (error) {
    const message = SetMessage(error, action.transition);
    yield put(PremiumAction.calculatePriceFailure(message));
  }
}


function* buyGiftWorker(action) {
  try {
    yield call(fetchStore, action.data);
    yield put(PremiumAction.buyGiftSuccess());
    yield put(replace({ pathname: "/" }));
  } catch (error) {
    SetMessage(error, true);
    yield put(PremiumAction.buyGiftFailure());
  }
}


function useWallet(data) {
  return premiumApi.calculatePrice(data);
}

function* useWalletWorker(action) {
  try {
    const response = yield call(useWallet, action.data);
    yield put(PremiumAction.useWalletSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(PremiumAction.useWalletFailure());
  }
}

function usePromoCode(data) {
  return premiumApi.calculatePrice(data);
}

function* usePromoCodeWorker(action) {
  try {
    const response = yield call(usePromoCode, action.data);
    yield put(PremiumAction.usePromoCodeSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(PremiumAction.usePromoCodeFailure());
  }
}

function fetchTransactionList(pageNumber) {
  return premiumApi.getList(pageNumber);
}

function* getListWorker(action) {
  try {
    const response = yield call(fetchTransactionList, action.pageNumber);
    yield put(PremiumAction.getListSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PremiumAction.getListFailure(message));
  }
}

function fetchTransactionListByProject() {
  return premiumApi.getByProject();
}

function* getListByProjectWorker() {
  try {
    const response = yield call(fetchTransactionListByProject);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PremiumAction.getListByProjectSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PremiumAction.getListByProjectFailure(message));
  }
}

function fetchStore(data) {
  return premiumApi.payStore(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    yield put(PremiumAction.payStoreSuccess(response.data));
    if (response.data.redirect_url) {
      window.location.href = response.data.redirect_url;
    } else {
      window.location.href = "/";
    }
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    SetMessage(error, true);
    yield put(PremiumAction.payStoreFailure());
  }
}

function fetchPromoCode() {
  return premiumApi.getPromoCode();
}

function* promoCode() {
  try {
    const response = yield call(fetchPromoCode);
    yield put(PremiumAction.getPromoCodeSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PremiumAction.getPromoCodeFailure(message));
  }
}

function fetchActivePlans(ownerId) {
  return premiumApi.getActivePlans(ownerId);
}

function* activePlan(action) {
  try {
    const response = yield call(fetchActivePlans, action.ownerId);
    yield put(PremiumAction.getActivePlansSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PremiumAction.getActivePlansFailure(message));
  }
}

function* getPremiumTransaction(action) {
  try {
    const response = yield call(getItemRequest, action.id);
    yield put(PremiumAction.getPremiumTransactionSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PremiumAction.getPremiumTransactionFailure(message));
  }
}
function getItemRequest(id) {
  return premiumApi.getTransaction(id);
}
